(() => {
  if (window.__clvrListLanding) return;
  window.__clvrListLanding = true;
  const regions = new Map();
  const markSubscribed = () => {
    try { window.localStorage.setItem('clvr-list-subscribed', '1'); }
    catch { try { window.sessionStorage.setItem('clvr-list-subscribed', '1'); } catch {} }
    window.dispatchEvent(new CustomEvent('clvr:list-subscribed'));
  };
  const setHidden = (element, hidden) => {
    if (element && element.hidden !== hidden) element.hidden = hidden;
  };
  const isVisible = (element) => {
    if (!element || !element.getClientRects().length) return false;
    const style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.visibility !== 'collapse';
  };
  const initialize = (root = document) => {
    root.querySelectorAll('[data-clvr-signup-success]').forEach((success) => {
      if (success.dataset.clvrSignupMarked) return;
      success.dataset.clvrSignupMarked = 'true';
      markSubscribed();
      const submittedForm = success.closest('form');
      if (submittedForm && window.location.hash === '#' + submittedForm.id) success.focus({ preventScroll: true });
    });
    root.querySelectorAll('[data-clvr-list-signup]').forEach((region) => {
      if (regions.has(region)) return;
      const embed = region.querySelector('[data-clvr-klaviyo-embed]');
      const fallback = region.querySelector('[data-clvr-native-signup]');
      const confirmation = region.querySelector('[data-clvr-klaviyo-success]');
      const sharedConsent = region.querySelector('[data-clvr-shared-consent]');
      if (fallback && sharedConsent) {
        fallback.querySelectorAll('input[type="email"]').forEach((input) => {
          const descriptions = (input.getAttribute('aria-describedby') || '').split(/\s+/).filter((id) => id && !id.endsWith('-consent'));
          input.setAttribute('aria-describedby', [sharedConsent.id, ...descriptions].join(' '));
        });
      }
      if (!embed || !fallback) return;
      const state = { region, embed, fallback, confirmation, submitted: false, keepNative: Boolean(fallback.querySelector('[data-clvr-signup-success], [role="alert"]')), observer: null, scheduled: false };
      state.sync = () => {
        state.scheduled = false;
        if (state.keepNative) {
          setHidden(embed, true);
          setHidden(fallback, false);
          setHidden(confirmation, true);
          return;
        }
        const visibleInput = Array.from(embed.querySelectorAll('input[type="email"], input[name="email"]')).some(isVisible);
        const visibleAction = Array.from(embed.querySelectorAll('button, input[type="submit"], [role="button"]')).some(isVisible);
        const rendered = visibleInput && visibleAction;
        const renderedConfirmation = state.submitted && Array.from(embed.children).some((child) => child.tagName !== 'STYLE' && child.tagName !== 'SCRIPT' && child.textContent.trim() && isVisible(child));
        const ready = rendered || renderedConfirmation;
        setHidden(fallback, ready || state.submitted);
        setHidden(confirmation, !state.submitted || ready);
        region.classList.toggle('clvr-list-signup--klaviyo-ready', ready);
      };
      state.schedule = () => {
        if (state.scheduled) return;
        state.scheduled = true;
        window.requestAnimationFrame(state.sync);
      };
      fallback.addEventListener('focusin', () => {
        if (fallback.hidden) return;
        state.keepNative = true;
        state.sync();
      });
      regions.set(region, state);
      if ('MutationObserver' in window) {
        state.observer = new MutationObserver(state.schedule);
        state.observer.observe(embed, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden', 'aria-hidden'] });
      }
      state.sync();
    });
  };
  window.addEventListener('klaviyoForms', (event) => {
    const detail = event.detail;
    if (!detail || !detail.formId) return;
    regions.forEach((state) => {
      if (detail.formId !== state.region.dataset.klaviyoFormId) return;
      if (detail.type === 'submit') {
        state.submitted = true;
        markSubscribed();
      }
      if (detail.type === 'embedOpen' || detail.type === 'submit') state.schedule();
    });
  });
  window.addEventListener('resize', () => regions.forEach((state) => state.schedule()));
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    regions.forEach((state, region) => {
      if (!event.target.contains(region)) return;
      if (state.observer) state.observer.disconnect();
      regions.delete(region);
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
})();
